import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.frequency');
import { AfterViewInit, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type BandKey = '2.4' | '5.8';

interface BandConfig {
    key: BandKey;
    label: string;
    rangeLabel: string;
    minMhz: number;
    maxMhz: number;
    fixedMhz: number;
    hops: number[];
    channels: string[];
    interferenceStart: number;
    interferenceEnd: number;
}

interface PeakTrail {
    frequency: number;
    bornAt: number;
}

interface PlotArea {
    left: number;
    right: number;
    top: number;
    bottom: number;
    width: number;
    height: number;
}

@Component({
    selector: 'wiz-page-frequency',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.frequency/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.text-brand-green {
  color: #72e5b6;
}

.rf-page {
  background: radial-gradient(circle at 78% -8%, rgba(69, 211, 154, 0.09), transparent 32rem), radial-gradient(circle at 8% 12%, rgba(69, 211, 154, 0.06), transparent 28rem), #0b1514;
}

.control-deck,
.spectrum-panel,
.waterfall-panel,
.metric-card {
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.18), inset 0 1px 0 rgba(143, 183, 174, 0.045);
}

.control-group {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.75rem;
  border-radius: 0.625rem;
  border: 1px solid rgba(123, 183, 160, 0.18);
  background: rgba(7, 19, 15, 0.58);
  padding: 0.625rem;
}

.control-label {
  display: flex;
  width: 7rem;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.5rem;
  color: #8ca59d;
  font-size: 0.625rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.control-label i {
  width: 0.875rem;
  color: #45d39a;
  text-align: center;
}

.control-options {
  display: grid;
  min-width: 0;
  flex: 1;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.375rem;
}

.control-button {
  display: flex;
  min-width: 0;
  cursor: pointer;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid transparent;
  border-radius: 0.45rem;
  background: rgba(16, 28, 27, 0.82);
  padding: 0.45rem 0.625rem;
  color: #8ca59d;
  transition: border-color 160ms ease, background 160ms ease, color 160ms ease;
}
.control-button span {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.6875rem;
  font-weight: 700;
}
.control-button small {
  margin-top: 0.08rem;
  color: #607a70;
  font-size: 0.5rem;
  letter-spacing: 0.04em;
}
.control-button:hover {
  border-color: rgba(69, 211, 154, 0.3);
  color: #edf7f2;
}
.control-button.is-active {
  border-color: rgba(69, 211, 154, 0.48);
  background: rgba(69, 211, 154, 0.14);
  color: #72e5b6;
  box-shadow: inset 0 0 16px rgba(69, 211, 154, 0.08);
}
.control-button.is-active small {
  color: #45d39a;
}

.interference-toggle {
  display: flex;
  min-width: 0;
  flex: 1;
  cursor: pointer;
  align-items: center;
  gap: 0.625rem;
  border: 1px solid rgba(123, 183, 160, 0.2);
  border-radius: 0.45rem;
  background: rgba(16, 28, 27, 0.82);
  padding: 0.45rem 0.625rem;
  color: #8ca59d;
  transition: border-color 160ms ease, background 160ms ease;
}
.interference-toggle strong {
  overflow: hidden;
  color: #d9e9e3;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.625rem;
  line-height: 1rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.interference-toggle small {
  color: #607a70;
  font-size: 0.5rem;
}
.interference-toggle.is-danger {
  border-color: rgba(244, 63, 94, 0.54);
  background: rgba(159, 18, 57, 0.15);
}
.interference-toggle.is-danger strong,
.interference-toggle.is-danger small {
  color: #fda4af;
}
.interference-toggle.is-danger .toggle-track {
  border-color: rgba(251, 113, 133, 0.72);
  background: rgba(244, 63, 94, 0.36);
}
.interference-toggle.is-danger .toggle-knob {
  transform: translateX(0.875rem);
  background: #fb7185;
  box-shadow: 0 0 10px rgba(244, 63, 94, 0.8);
}

.toggle-track {
  position: relative;
  display: block;
  width: 2rem;
  height: 1.125rem;
  flex: 0 0 auto;
  border: 1px solid #28453b;
  border-radius: 9999px;
  background: #101c1b;
  transition: border-color 160ms ease, background 160ms ease;
}

.toggle-knob {
  position: absolute;
  top: 0.1875rem;
  left: 0.1875rem;
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 9999px;
  background: #6f8b81;
  transition: transform 180ms ease, background 180ms ease, box-shadow 180ms ease;
}

.metric-card {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 6rem;
  align-items: center;
  gap: 0.75rem;
  overflow: hidden;
  border: 1px solid #203731;
  border-radius: 0.75rem;
  background: linear-gradient(145deg, rgba(16, 28, 27, 0.92), rgba(7, 16, 18, 0.92));
  padding: 0.875rem;
}
.metric-card::after {
  position: absolute;
  right: -1.5rem;
  bottom: -2.4rem;
  width: 6rem;
  height: 6rem;
  border: 1px solid rgba(69, 211, 154, 0.08);
  border-radius: 9999px;
  content: "";
}
.metric-card.metric-danger {
  border-color: rgba(244, 63, 94, 0.45);
  background: linear-gradient(145deg, rgba(76, 5, 25, 0.42), rgba(16, 28, 27, 0.92));
}
.metric-card.metric-danger::after {
  border-color: rgba(244, 63, 94, 0.13);
}

.metric-icon {
  display: grid;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 auto;
  place-items: center;
  border: 1px solid rgba(71, 85, 105, 0.6);
  border-radius: 0.625rem;
  background: rgba(16, 28, 27, 0.86);
  font-size: 0.875rem;
}

.metric-label {
  color: #6f8b81;
  font-size: 0.5625rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.metric-value {
  overflow: hidden;
  margin-top: 0.2rem;
  color: #edf7f2;
  font-size: clamp(0.95rem, 2vw, 1.25rem);
  font-weight: 700;
  letter-spacing: -0.03em;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.metric-value span {
  margin-left: 0.25rem;
  color: #6f8b81;
  font-size: 0.625rem;
  font-weight: 500;
  letter-spacing: 0;
}

.metric-status {
  overflow: hidden;
  margin-top: 0.3rem;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.025em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.metric-detail {
  overflow: hidden;
  margin-top: 0.25rem;
  color: #607a70;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.5rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.panel-header {
  display: flex;
  min-height: 3.5rem;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  border-bottom: 1px solid rgba(123, 183, 160, 0.15);
  background: linear-gradient(90deg, rgba(16, 28, 27, 0.78), rgba(7, 16, 18, 0.68));
  padding: 0.75rem 1rem;
}

.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}
.legend-item i {
  display: block;
  width: 1.3rem;
  height: 0.1rem;
  border-radius: 9999px;
  box-shadow: 0 0 7px currentColor;
}

.spectrum-canvas {
  height: clamp(18rem, 38vh, 25rem);
}

.waterfall-canvas {
  height: clamp(11rem, 24vh, 15rem);
  image-rendering: auto;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border: 1px solid;
  border-radius: 0.35rem;
  padding: 0.32rem 0.5rem;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.55rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  backdrop-filter: blur(8px);
}
.status-badge.status-stable {
  border-color: rgba(52, 211, 153, 0.42);
  background: rgba(6, 78, 59, 0.35);
  color: #72e5b6;
  box-shadow: 0 0 18px rgba(52, 211, 153, 0.08);
}
.status-badge.status-critical {
  border-color: rgba(244, 63, 94, 0.55);
  background: rgba(136, 19, 55, 0.46);
  color: #fda4af;
  box-shadow: 0 0 20px rgba(244, 63, 94, 0.15);
  animation: alertPulse 1.05s ease-in-out infinite;
}

.color-scale {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #607a70;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.5rem;
}

.scale-gradient {
  display: block;
  width: 8rem;
  height: 0.35rem;
  border-radius: 9999px;
  background: linear-gradient(90deg, #06100d, #123d31, #2a8a69, #45d39a, #facc15, #f43f5e);
}

.hop-cell {
  position: relative;
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.18rem;
  overflow: hidden;
  border: 1px solid rgba(123, 183, 160, 0.2);
  border-radius: 0.5rem;
  background: rgba(7, 19, 15, 0.58);
  padding: 0.65rem;
}
.hop-cell strong {
  white-space: nowrap;
}
.hop-cell small {
  margin-left: 0.15rem;
  color: #607a70;
  font-size: 0.48rem;
}
.hop-cell.is-current {
  border-color: rgba(69, 211, 154, 0.5);
  background: rgba(6, 78, 59, 0.18);
  box-shadow: inset 0 0 20px rgba(69, 211, 154, 0.05);
}
.hop-cell.is-current strong {
  color: #72e5b6;
}
.hop-cell.is-current .hop-indicator {
  color: #45d39a;
}

.hop-indicator {
  color: #607a70;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.45rem;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.guard-ring {
  display: grid;
  width: 2.5rem;
  height: 2.5rem;
  flex: 0 0 auto;
  place-items: center;
  border: 1px solid rgba(52, 211, 153, 0.45);
  border-radius: 9999px;
  background: rgba(6, 78, 59, 0.18);
  color: #72e5b6;
  box-shadow: 0 0 22px rgba(52, 211, 153, 0.1);
}
.guard-ring.guard-danger {
  border-color: rgba(244, 63, 94, 0.55);
  background: rgba(136, 19, 55, 0.28);
  color: #fda4af;
  box-shadow: 0 0 22px rgba(244, 63, 94, 0.14);
}

@keyframes alertPulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.64;
  }
}
@media (max-width: 767px) {
  .control-group {
    align-items: stretch;
    flex-direction: column;
    gap: 0.5rem;
  }
  .control-label {
    width: auto;
  }
  .panel-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .spectrum-canvas {
    height: 18rem;
  }
  .metric-card {
    align-items: flex-start;
    flex-direction: column;
    min-height: 7.5rem;
  }
  .metric-icon {
    width: 1.875rem;
    height: 1.875rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  .status-badge.status-critical {
    animation: none;
  }
  .control-button,
  .interference-toggle,
  .toggle-knob {
    transition: none;
  }
}`],
})
export class PageFrequencyComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('spectrumCanvas', { static: true })
    public spectrumCanvas!: ElementRef<HTMLCanvasElement>;

    @ViewChild('waterfallCanvas', { static: true })
    public waterfallCanvas!: ElementRef<HTMLCanvasElement>;

    public band: BandKey = '2.4';
    public fhssEnabled = true;
    public interferenceEnabled = false;
    public currentFrequency = 2437;
    public currentChannel = 'CH 6';
    public signalStrength = -40;
    public noiseFloor = -95;
    public snr = 55;
    public isJammed = false;
    public sweepTime = '00:00:00.000';

    private readonly bandwidthMhz = 20;
    private readonly sampleCount = 512;
    private readonly bands: Record<BandKey, BandConfig> = {
        '2.4': {
            key: '2.4',
            label: '2.4 GHz',
            rangeLabel: '2.400 — 2.4835 GHz',
            minMhz: 2400,
            maxMhz: 2483.5,
            fixedMhz: 2412,
            hops: [2412, 2437, 2462],
            channels: ['CH 1', 'CH 6', 'CH 11'],
            interferenceStart: 2410,
            interferenceEnd: 2430
        },
        '5.8': {
            key: '5.8',
            label: '5.8 GHz',
            rangeLabel: '5.725 — 5.850 GHz',
            minMhz: 5725,
            maxMhz: 5850,
            fixedMhz: 5745,
            hops: [5745, 5785, 5825],
            channels: ['CH 149', 'CH 157', 'CH 165'],
            interferenceStart: 5750,
            interferenceEnd: 5775
        }
    };

    private spectrumValues = new Float32Array(this.sampleCount);
    private peakTrails: PeakTrail[] = [];
    private animationFrameId: number | null = null;
    private resizeObserver: ResizeObserver | null = null;
    private nextHopAt = 0;
    private nextUiRefreshAt = 0;
    private phase = 0;
    private canvasNeedsReset = true;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public ngAfterViewInit() {
        this.resizeObserver = new ResizeObserver(() => {
            this.canvasNeedsReset = true;
        });
        this.resizeObserver.observe(this.spectrumCanvas.nativeElement);
        this.resizeObserver.observe(this.waterfallCanvas.nativeElement);

        const now = performance.now();
        this.nextHopAt = now + this.randomHopDelay();
        this.animationFrameId = requestAnimationFrame((timestamp) => this.animate(timestamp));
    }

    public ngOnDestroy() {
        if (this.animationFrameId !== null) {
            cancelAnimationFrame(this.animationFrameId);
        }
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    public get bandConfig(): BandConfig {
        return this.bands[this.band];
    }

    public get formattedFrequency(): string {
        return this.currentFrequency.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    public get formattedSnr(): string {
        const value = Math.round(this.snr);
        return (value >= 0 ? '+' : '') + value + ' dB';
    }

    public get protocolLabel(): string {
        return (this.fhssEnabled ? 'FHSS ACTIVE' : 'FIXED CHANNEL') + ' / 20 MHz BW / ISM';
    }

    public get linkStatus(): string {
        return this.isJammed ? 'JAMMED / SNR CRITICAL' : 'LINK STABLE';
    }

    public setBand(nextBand: BandKey) {
        if (this.band === nextBand) return;

        this.band = nextBand;
        const config = this.bandConfig;
        this.currentFrequency = this.fhssEnabled ? config.hops[1] : config.fixedMhz;
        this.peakTrails = [];
        this.nextHopAt = performance.now() + this.randomHopDelay();
        this.canvasNeedsReset = true;
        this.updateChannelLabel();
        this.updateTelemetry(performance.now());
        this.service.render();
    }

    public toggleFhss() {
        this.peakTrails.push({
            frequency: this.currentFrequency,
            bornAt: performance.now()
        });
        this.fhssEnabled = !this.fhssEnabled;
        const config = this.bandConfig;
        this.currentFrequency = this.fhssEnabled ? config.hops[1] : config.fixedMhz;
        this.nextHopAt = performance.now() + this.randomHopDelay();
        this.updateChannelLabel();
        this.updateTelemetry(performance.now());
        this.service.render();
    }

    public toggleInterference() {
        this.interferenceEnabled = !this.interferenceEnabled;
        this.updateTelemetry(performance.now());
        this.service.render();
    }

    public isCurrentHop(frequency: number): boolean {
        return Math.abs(this.currentFrequency - frequency) < 0.1;
    }

    private animate(timestamp: number) {
        this.phase += 0.028;

        if (this.fhssEnabled && timestamp >= this.nextHopAt) {
            this.hopFrequency(timestamp);
        }

        this.drawSpectrum(timestamp);
        this.drawWaterfall();

        if (timestamp >= this.nextUiRefreshAt) {
            this.updateTelemetry(timestamp);
            this.nextUiRefreshAt = timestamp + 120;
            this.service.render();
        }

        this.animationFrameId = requestAnimationFrame((nextTimestamp) => this.animate(nextTimestamp));
    }

    private hopFrequency(timestamp: number) {
        const config = this.bandConfig;
        const candidates = config.hops.filter((frequency) => frequency !== this.currentFrequency);
        const nextFrequency = candidates[Math.floor(Math.random() * candidates.length)];

        this.peakTrails.push({
            frequency: this.currentFrequency,
            bornAt: timestamp
        });
        this.currentFrequency = nextFrequency;
        this.updateChannelLabel();
        this.nextHopAt = timestamp + this.randomHopDelay();
    }

    private randomHopDelay(): number {
        return 150 + Math.random() * 150;
    }

    private updateChannelLabel() {
        const config = this.bandConfig;
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        config.hops.forEach((frequency, index) => {
            const distance = Math.abs(frequency - this.currentFrequency);
            if (distance < nearestDistance) {
                nearestDistance = distance;
                nearestIndex = index;
            }
        });

        this.currentChannel = config.channels[nearestIndex];
    }

    private updateTelemetry(timestamp: number) {
        const config = this.bandConfig;
        const inInterference = this.interferenceEnabled
            && this.currentFrequency >= config.interferenceStart
            && this.currentFrequency <= config.interferenceEnd;

        this.signalStrength = -40 + Math.sin(timestamp / 240) * 1.8 + (Math.random() - 0.5) * 1.2;

        if (inInterference) {
            const range = config.interferenceEnd - config.interferenceStart;
            const normalized = (this.currentFrequency - config.interferenceStart) / range;
            const dome = Math.sin(Math.PI * Math.max(0, Math.min(1, normalized)));
            this.noiseFloor = Math.min(-18, -48 + dome * 28 + (Math.random() - 0.5) * 7);
        } else {
            this.noiseFloor = -95 + Math.sin(timestamp / 680) * 1.5 + (Math.random() - 0.5) * 1.8;
        }

        this.snr = this.signalStrength - this.noiseFloor;
        this.isJammed = inInterference;

        const date = new Date();
        this.sweepTime = [
            String(date.getHours()).padStart(2, '0'),
            String(date.getMinutes()).padStart(2, '0'),
            String(date.getSeconds()).padStart(2, '0')
        ].join(':') + '.' + String(date.getMilliseconds()).padStart(3, '0');
    }

    private drawSpectrum(timestamp: number) {
        const canvas = this.spectrumCanvas.nativeElement;
        const context = canvas.getContext('2d');
        if (!context) return;

        const dimensions = this.prepareCanvas(canvas, context);
        const width = dimensions.width;
        const height = dimensions.height;
        const plot: PlotArea = {
            left: 58,
            right: 18,
            top: 34,
            bottom: 36,
            width: width - 76,
            height: height - 70
        };

        const background = context.createLinearGradient(0, 0, 0, height);
        background.addColorStop(0, '#0a1714');
        background.addColorStop(1, '#06100e');
        context.fillStyle = background;
        context.fillRect(0, 0, width, height);

        this.drawGrid(context, plot);
        this.drawInterferenceZone(context, plot);

        for (let index = 0; index < this.sampleCount; index += 1) {
            const frequency = this.indexToFrequency(index);
            const baseNoise = -95
                + Math.sin(this.phase * 0.73 + index * 0.31) * 1.7
                + Math.sin(this.phase * 1.37 + index * 0.087) * 1.1
                + (Math.random() - 0.5) * 2.4;

            const signalGaussian = Math.exp(
                -Math.pow(frequency - this.currentFrequency, 2)
                / (2 * Math.pow(this.bandwidthMhz / 4.25, 2))
            );
            const carrier = -99 + signalGaussian * (59 + Math.sin(this.phase * 1.8) * 1.5);

            let value = Math.max(baseNoise, carrier);
            if (this.interferenceEnabled) {
                value = Math.max(value, this.interferencePower(frequency, index));
            }

            this.spectrumValues[index] = value;
        }

        this.peakTrails = this.peakTrails.filter((trail) => timestamp - trail.bornAt < 1350);
        this.peakTrails.forEach((trail) => {
            const age = timestamp - trail.bornAt;
            this.drawPeakCurve(context, plot, trail.frequency, Math.max(0, 0.28 * (1 - age / 1350)), true);
        });

        this.drawSpectrumFill(context, plot);
        this.drawPeakCurve(context, plot, this.currentFrequency, 1, false);
        this.drawBandwidthGuide(context, plot);

        const sweepX = plot.left + ((timestamp / 2400) % 1) * plot.width;
        const sweepGradient = context.createLinearGradient(sweepX - 28, 0, sweepX + 8, 0);
        sweepGradient.addColorStop(0, 'rgba(56, 189, 248, 0)');
        sweepGradient.addColorStop(1, 'rgba(56, 189, 248, 0.13)');
        context.fillStyle = sweepGradient;
        context.fillRect(sweepX - 28, plot.top, 36, plot.height);
    }

    private drawGrid(context: CanvasRenderingContext2D, plot: PlotArea) {
        const config = this.bandConfig;
        context.save();
        context.lineWidth = 1;
        context.font = '10px ui-monospace, SFMono-Regular, Menlo, monospace';
        context.fillStyle = '#6f8c82';
        context.textBaseline = 'middle';

        for (let step = 0; step <= 5; step += 1) {
            const y = plot.top + (plot.height * step / 5);
            const dbm = -step * 20;

            context.strokeStyle = step === 5 ? '#28453b' : 'rgba(123, 183, 160, 0.20)';
            context.beginPath();
            context.moveTo(plot.left, y);
            context.lineTo(plot.left + plot.width, y);
            context.stroke();

            context.textAlign = 'right';
            context.fillText(dbm + '', plot.left - 9, y);
        }

        for (let step = 0; step <= 5; step += 1) {
            const x = plot.left + (plot.width * step / 5);
            const frequency = config.minMhz + ((config.maxMhz - config.minMhz) * step / 5);

            context.strokeStyle = 'rgba(84, 122, 108, 0.32)';
            context.beginPath();
            context.moveTo(x, plot.top);
            context.lineTo(x, plot.top + plot.height);
            context.stroke();

            context.textAlign = step === 0 ? 'left' : (step === 5 ? 'right' : 'center');
            context.textBaseline = 'top';
            context.fillText((frequency / 1000).toFixed(3), x, plot.top + plot.height + 10);
        }

        context.fillStyle = '#475569';
        context.textAlign = 'left';
        context.textBaseline = 'top';
        context.fillText('dBm', 12, plot.top - 2);
        context.textAlign = 'right';
        context.fillText('GHz', plot.left + plot.width, plot.top + plot.height + 23);
        context.restore();
    }

    private drawInterferenceZone(context: CanvasRenderingContext2D, plot: PlotArea) {
        if (!this.interferenceEnabled) return;

        const config = this.bandConfig;
        const startX = this.frequencyToX(config.interferenceStart, plot);
        const endX = this.frequencyToX(config.interferenceEnd, plot);
        const gradient = context.createLinearGradient(startX, 0, endX, 0);
        gradient.addColorStop(0, 'rgba(244, 63, 94, 0.06)');
        gradient.addColorStop(0.5, 'rgba(244, 63, 94, 0.19)');
        gradient.addColorStop(1, 'rgba(244, 63, 94, 0.06)');

        context.save();
        context.fillStyle = gradient;
        context.fillRect(startX, plot.top, endX - startX, plot.height);

        context.strokeStyle = 'rgba(251, 113, 133, 0.42)';
        context.setLineDash([4, 5]);
        context.strokeRect(startX, plot.top, endX - startX, plot.height);
        context.setLineDash([]);

        context.fillStyle = '#fb7185';
        context.font = '600 9px ui-monospace, SFMono-Regular, Menlo, monospace';
        context.textAlign = 'center';
        context.textBaseline = 'top';
        context.fillText('RF INTERFERENCE', (startX + endX) / 2, plot.top + 8);
        context.restore();
    }

    private drawSpectrumFill(context: CanvasRenderingContext2D, plot: PlotArea) {
        const lineGradient = context.createLinearGradient(0, plot.top, 0, plot.top + plot.height);
        lineGradient.addColorStop(0, '#facc15');
        lineGradient.addColorStop(0.36, '#45d39a');
        lineGradient.addColorStop(1, '#72e5b6');

        const fillGradient = context.createLinearGradient(0, plot.top, 0, plot.top + plot.height);
        fillGradient.addColorStop(0, 'rgba(69, 211, 154, 0.30)');
        fillGradient.addColorStop(1, 'rgba(69, 211, 154, 0.018)');

        context.save();
        context.beginPath();
        for (let index = 0; index < this.sampleCount; index += 1) {
            const x = plot.left + plot.width * index / (this.sampleCount - 1);
            const y = this.dbmToY(this.spectrumValues[index], plot);
            if (index === 0) context.moveTo(x, y);
            else context.lineTo(x, y);
        }
        context.lineTo(plot.left + plot.width, plot.top + plot.height);
        context.lineTo(plot.left, plot.top + plot.height);
        context.closePath();
        context.fillStyle = fillGradient;
        context.fill();

        context.beginPath();
        for (let index = 0; index < this.sampleCount; index += 1) {
            const x = plot.left + plot.width * index / (this.sampleCount - 1);
            const y = this.dbmToY(this.spectrumValues[index], plot);
            if (index === 0) context.moveTo(x, y);
            else context.lineTo(x, y);
        }
        context.strokeStyle = lineGradient;
        context.lineWidth = 1.7;
        context.shadowColor = 'rgba(69, 211, 154, 0.52)';
        context.shadowBlur = 8;
        context.stroke();
        context.restore();
    }

    private drawPeakCurve(
        context: CanvasRenderingContext2D,
        plot: PlotArea,
        frequency: number,
        alpha: number,
        trail: boolean
    ) {
        const sigma = this.bandwidthMhz / 4.25;
        const start = Math.max(this.bandConfig.minMhz, frequency - this.bandwidthMhz);
        const end = Math.min(this.bandConfig.maxMhz, frequency + this.bandwidthMhz);
        const steps = 90;

        context.save();
        context.beginPath();
        for (let step = 0; step <= steps; step += 1) {
            const sampleFrequency = start + (end - start) * step / steps;
            const gaussian = Math.exp(-Math.pow(sampleFrequency - frequency, 2) / (2 * sigma * sigma));
            const dbm = -99 + gaussian * 59;
            const x = this.frequencyToX(sampleFrequency, plot);
            const y = this.dbmToY(dbm, plot);
            if (step === 0) context.moveTo(x, y);
            else context.lineTo(x, y);
        }

        context.strokeStyle = trail
            ? 'rgba(114, 229, 182, ' + alpha + ')'
            : 'rgba(110, 231, 183, ' + alpha + ')';
        context.lineWidth = trail ? 1.1 : 2.2;
        context.shadowColor = trail ? '#72e5b6' : '#45d39a';
        context.shadowBlur = trail ? 5 : 11;
        context.stroke();
        context.restore();
    }

    private drawBandwidthGuide(context: CanvasRenderingContext2D, plot: PlotArea) {
        const halfBandwidth = this.bandwidthMhz / 2;
        const startX = this.frequencyToX(this.currentFrequency - halfBandwidth, plot);
        const endX = this.frequencyToX(this.currentFrequency + halfBandwidth, plot);
        const centerX = this.frequencyToX(this.currentFrequency, plot);
        const guideY = plot.top + 20;

        context.save();
        context.strokeStyle = this.isJammed ? '#fb7185' : '#45d39a';
        context.fillStyle = this.isJammed ? '#fb7185' : '#72e5b6';
        context.lineWidth = 1;
        context.setLineDash([5, 4]);

        context.beginPath();
        context.moveTo(startX, guideY);
        context.lineTo(endX, guideY);
        context.moveTo(startX, guideY - 5);
        context.lineTo(startX, guideY + 5);
        context.moveTo(endX, guideY - 5);
        context.lineTo(endX, guideY + 5);
        context.stroke();
        context.setLineDash([]);

        context.beginPath();
        context.arc(centerX, this.dbmToY(-40, plot), 3.3, 0, Math.PI * 2);
        context.fill();

        const label = this.formattedFrequency + ' MHz  •  ' + this.bandwidthMhz + ' MHz BW';
        context.font = '600 10px ui-monospace, SFMono-Regular, Menlo, monospace';
        context.textAlign = 'center';
        context.textBaseline = 'bottom';
        const textWidth = context.measureText(label).width;
        context.fillStyle = 'rgba(5, 11, 19, 0.82)';
        context.fillRect(centerX - textWidth / 2 - 7, guideY - 19, textWidth + 14, 15);
        context.fillStyle = this.isJammed ? '#fda4af' : '#9aebc8';
        context.fillText(label, centerX, guideY - 6);
        context.restore();
    }

    private drawWaterfall() {
        const canvas = this.waterfallCanvas.nativeElement;
        const context = canvas.getContext('2d');
        if (!context) return;

        const dimensions = this.prepareCanvas(canvas, context);
        const width = dimensions.width;
        const height = dimensions.height;
        const dpr = dimensions.dpr;
        const pixelWidth = canvas.width;
        const pixelHeight = canvas.height;
        const rowHeight = Math.max(1, Math.round(dpr));

        context.setTransform(1, 0, 0, 1, 0, 0);
        context.globalCompositeOperation = 'copy';
        context.drawImage(
            canvas,
            0,
            0,
            pixelWidth,
            Math.max(1, pixelHeight - rowHeight),
            0,
            rowHeight,
            pixelWidth,
            Math.max(1, pixelHeight - rowHeight)
        );
        context.globalCompositeOperation = 'source-over';

        context.setTransform(dpr, 0, 0, dpr, 0, 0);
        const segmentWidth = width / this.sampleCount;
        for (let index = 0; index < this.sampleCount; index += 1) {
            context.fillStyle = this.powerColor(this.spectrumValues[index]);
            context.fillRect(index * segmentWidth, 0, segmentWidth + 1, rowHeight / dpr + 0.5);
        }

        const fade = context.createLinearGradient(0, 0, width, 0);
        fade.addColorStop(0, 'rgba(6, 16, 13, 0.32)');
        fade.addColorStop(0.04, 'rgba(6, 16, 13, 0)');
        fade.addColorStop(0.96, 'rgba(6, 16, 13, 0)');
        fade.addColorStop(1, 'rgba(6, 16, 13, 0.32)');
        context.fillStyle = fade;
        context.fillRect(0, 0, width, height);
    }

    private interferencePower(frequency: number, index: number): number {
        const config = this.bandConfig;
        if (frequency < config.interferenceStart || frequency > config.interferenceEnd) {
            return -120;
        }

        const normalized = (frequency - config.interferenceStart)
            / (config.interferenceEnd - config.interferenceStart);
        const dome = Math.sin(Math.PI * normalized);
        const saw = ((index % 11) / 10 - 0.5) * 9;
        const roughness = Math.sin(index * 1.73 + this.phase * 5.8) * 3.5;
        return Math.min(-18, -48 + dome * 28 + saw + roughness);
    }

    private powerColor(dbm: number): string {
        const stops = [
            { value: -100, color: [4, 13, 13] },
            { value: -88, color: [11, 42, 35] },
            { value: -72, color: [28, 115, 86] },
            { value: -55, color: [69, 211, 154] },
            { value: -36, color: [250, 204, 21] },
            { value: -15, color: [244, 63, 94] }
        ];

        const bounded = Math.max(-100, Math.min(-15, dbm));
        for (let index = 0; index < stops.length - 1; index += 1) {
            const start = stops[index];
            const end = stops[index + 1];
            if (bounded <= end.value) {
                const ratio = (bounded - start.value) / (end.value - start.value);
                const rgb = start.color.map((channel, channelIndex) => {
                    return Math.round(channel + (end.color[channelIndex] - channel) * ratio);
                });
                return 'rgb(' + rgb.join(',') + ')';
            }
        }

        return 'rgb(244,63,94)';
    }

    private prepareCanvas(
        canvas: HTMLCanvasElement,
        context: CanvasRenderingContext2D
    ): { width: number; height: number; dpr: number } {
        const rect = canvas.getBoundingClientRect();
        const width = Math.max(320, Math.floor(rect.width));
        const height = Math.max(120, Math.floor(rect.height));
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const targetWidth = Math.floor(width * dpr);
        const targetHeight = Math.floor(height * dpr);

        if (
            this.canvasNeedsReset
            || canvas.width !== targetWidth
            || canvas.height !== targetHeight
        ) {
            canvas.width = targetWidth;
            canvas.height = targetHeight;
            context.setTransform(1, 0, 0, 1, 0, 0);
            context.fillStyle = '#06100e';
            context.fillRect(0, 0, targetWidth, targetHeight);
        }

        context.setTransform(dpr, 0, 0, dpr, 0, 0);
        this.canvasNeedsReset = false;
        return { width, height, dpr };
    }

    private indexToFrequency(index: number): number {
        const config = this.bandConfig;
        return config.minMhz + (config.maxMhz - config.minMhz) * index / (this.sampleCount - 1);
    }

    private frequencyToX(frequency: number, plot: PlotArea): number {
        const config = this.bandConfig;
        const normalized = (frequency - config.minMhz) / (config.maxMhz - config.minMhz);
        return plot.left + Math.max(0, Math.min(1, normalized)) * plot.width;
    }

    private dbmToY(dbm: number, plot: PlotArea): number {
        const normalized = (Math.max(-100, Math.min(0, dbm)) + 100) / 100;
        return plot.top + plot.height - normalized * plot.height;
    }
}

export default PageFrequencyComponent;